import styled from 'styled-components';

const Checkbox = styled.input`
  -moz-appearance:none;
  -webkit-appearance:none;
  -o-appearance:none;

  :hover{
    cursor: pointer;
  }
 
  :before{
    content: "✔";
    font-size: 16px;
    color: transparent !important;
    display: block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    border: 1px solid #F07E31;
    border-radius: 2px;
  }

  :checked:before{
    color: #F07E31 !important;
  }
`;

export default Checkbox;
